import { useContext, useState } from "react";
import styles from "./styles.module.css";
import CloseIcon from "@mui/icons-material/Close";
import DataTable from "../../utils/DataTable";
import Info from "../../utils/Alert/Info";
import DateTimeHelpers from "helpers/DateTimeHelpers";
import Button from "@mui/material/Button";
import PrinterImg from "images/svg/printer.svg";
import { roundOff } from "helpers/NumberFormatHelper";
import ShopContext from "../../../context/ShopContext";
import * as ReportHelper from "helpers/ReportHelper";
import { getShiftFromLocalStorage } from "helpers/ReportHelper";
import * as DeletedCartHelper from "helpers/DeletedCartHelper";
import { STORAGE_KEYS } from "const";
import DeleteCartDetailsPopup from "./DeleteCartDetailsPopup";

export default function DeletedCartsPopup({ onClose, deletedCarts, shiftId }) {
  const { shop } = useContext(ShopContext);
  const [selectedSaleId, setSelectedSaleId] = useState(null);

  console.log("deletedCarts", deletedCarts);

  const listHeader = [
    {
      id: "sn",
      label: "#",
      type: "callback",
      width: "40px",
      viewRender: (item) => deletedCarts.indexOf(item) + 1,
    },
    {
      id: "createdAt",
      label: "Created At",
      type: "callback",
      width: "180px",
      viewRender: (item) => DateTimeHelpers.formatDateAndTime(item.createdAt),
    },
    {
      id: "cartNumber",
      label: "Cart No",
      type: "text",
      width: "80px",
    },
    {
      id: "deletedAt",
      label: "Deleted At",
      type: "callback",
      width: "180px",
      viewRender: (item) => DateTimeHelpers.formatDateAndTime(item.deletedAt),
    },
    {
      id: "amount",
      label: "Amount",
      type: "callback",
      width: "100px",
      viewRender: (item) => roundOff(item.amount || 0),
    },
  ];

  const handlePrint = async () => {
    try {
      if (!deletedCarts || deletedCarts.length === 0) return;
      const currentShiftId = shiftId || localStorage.getItem(STORAGE_KEYS.SHIFT_ID);
      const slipBytes = DeletedCartHelper.getDeletedCartPrintText(
        deletedCarts,
        shop,
        getShiftFromLocalStorage(currentShiftId),
      );
      await ReportHelper.printReport({ reportText: slipBytes, fallbackFunction: window.print });
    } catch (err) {
      console.error("Failed to print deleted carts", err);
    }
  };

  return (
    <div className={styles.popUp}>
      <div className={styles.contentWrapper}>
        <div className={styles.headSec}>
          <h2 className={styles.editTitle}>Deleted Carts</h2>
          <div className={styles.actionSection}>
            <div className={styles.buttonBar}>
              <Button
                className={`${styles.button} ${styles.printBtn}`}
                onClick={handlePrint}
                startIcon={<img src={PrinterImg} alt="Print" className={styles.iconSmall} />}
                disabled={!deletedCarts || deletedCarts.length === 0}
              >
                Print
              </Button>
            </div>
            <CloseIcon style={{ color: "rgba(124, 124, 125, 1)", cursor: "pointer" }} onClick={onClose} />
          </div>
        </div>
        <div className={styles.tableContent}>
          {deletedCarts && deletedCarts.length > 0 ? (
            <DataTable
              columns={listHeader}
              rows={deletedCarts}
              rowClickListener={(item) => setSelectedSaleId(item.cartNumber)}
            />
          ) : (
            <Info title={"No Deleted Carts"} content={"There are no deleted carts for this shift."} />
          )}
        </div>
      </div>

      {selectedSaleId && (
        <DeleteCartDetailsPopup
          open={!!selectedSaleId}
          onClose={() => setSelectedSaleId(null)}
          deletedCart={deletedCarts.find((c) => c.cartNumber === selectedSaleId)}
        />
      )}
    </div>
  );
}
